import InfoRaida from './info-raida';
export default InfoRaida